import * as caseFilterStore from '../insights/caseFilter.js';
import { dispatch } from '../internal.js';
import { setSelectedCreditorId } from '../internal.js';
import * as actionTypes from './actionTypes.js';
export const select = (selected) => {
    setSelectedCreditorId(selected);
    caseFilterStore.setSelectedCreditors([selected]);
    dispatch({ type: actionTypes.SELECT_CREDITOR, payload: { selected } });
};
//# sourceMappingURL=actions.js.map